'use client';

import { Card, HttpEditor } from '@terra/ui-design-system';
import {
  formatHttpRequest,
  type HttpHeaders,
  type HttpRequestModel,
} from '@terra/shared-utils';
import { useTranslations } from 'next-intl';

type OriginalRequestPopoverContentProps = {
  method: string;
  url: string;
  headers?: HttpHeaders;
  originalBody?: string;
  httpVersion?: string;
};

export function OriginalRequestPopoverContent({
  method,
  url,
  headers,
  originalBody,
  httpVersion = '1.1',
}: OriginalRequestPopoverContentProps) {
  const t = useTranslations('httpHistory');
  const request: HttpRequestModel = {
    method,
    url,
    httpVersion,
    headers: headers ?? {},
    body: originalBody,
  };
  const rawRequest = formatHttpRequest(request);

  return (
    <Card.Root maxW="480px" w="full" boxShadow="none" borderWidth="0">
      <Card.Header px="3" pt="3" pb="2">
        <Card.Title fontSize="xs">{t('originalRequest')}</Card.Title>
      </Card.Header>
      <Card.Body px="0" pb="0" pt="0">
        <HttpEditor
          value={rawRequest}
          readOnly
          hideToolbars
          showStatusBar={false}
          showLineNumbers={false}
          height="240px"
          maxHeight="240px"
        />
      </Card.Body>
    </Card.Root>
  );
}
